module.exports = __webpack_public_path__ + "media/images/three-dots-b7283eaf4cca6bf9b09c8c454862ad76.svg";